<template>
    <div v-if="userStore.user.isBusiness">
        <template v-if="settingStore.isDashboardBannerEnable == 1">
            <div v-html="settingStore.dashboardBanner"></div>
        </template>
        <div v-if="_.includes(billingStore.SUBSCRIPTION_STATUSES, userStore.user.subscription_status)" class="alert alert-warning" role="alert">
            <div class="alert-body">
                {{ localizationStore.translate("subscription.status." + userStore.user.subscription_status) }}
                <router-link
                    :to="{ name: 'billing-subscriptions-plan'}"
                    class="alert-link"
                >
                    Billing Portal
                </router-link>
            </div>
        </div>
        <div v-if="userStore.user.canAvailBlackFridaySale" class="alert alert-primary" role="alert">
            <div class="alert-body">
                UNLOCK HUGE SAVINGS! BLACK FRIDAY DEAL 🎁 3-Months Access!
                <a
                    href="#"
                    class="alert-link"
                    @click.stop.prevent="openModal('#sale-plans')"
                >
                    CLICK HERE
                </a>
            </div>
        </div>
        <div v-if="userStore.user.canAvailYearEndSale" class="alert alert-primary" role="alert">
            <div class="alert-body">
                UNLOCK HUGE SAVINGS! YEAR END DEAL 🎁 3-Months Access!
                <a
                    href="#"
                    class="alert-link"
                    @click.stop.prevent="openModal('#year-end-sale-modal')"
                >
                    CLICK HERE
                </a>
            </div>
        </div>
        <div class="row match-height mx-auto my-auto" >
            <business-clients />
            <business-company-details></business-company-details>
            <business-settings></business-settings>
        </div>
        <clients-table :teamMember="userStore.user.isTeamMember" :teamAdmin="userStore.user.isBusiness" />
        <company-detail-modal></company-detail-modal>
        <company-business-setting></company-business-setting>
        <add-client-modal></add-client-modal>
        <!-- tutorial models -->
        <video-player-component
            element_id="cf_biz_add_new_user_modal_video"
            title="Add New Client Tutorial"
            source="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/creditfixrrbusiness_addnewclient.mp4"
        />
        <video-player-component
            element_id="cf_biz_import_clients_modal_video"
            title="Import Clients Tutorial"
            source="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/DisputeLetters/CreditfixrrBusinessClientImport.mp4"
        />
        <video-player-component
            element_id="cf_biz_operations_modal_video"
            title="Creditfixrr Business Operations Tutorial"
            source="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/creditfixrrbusiness_businessoperations.mp4"
        />
        <video-player-component
            element_id="cf_biz_settings_modal_video"
            title="Creditfixrr Business Company Settings Tutorial"
            source="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/creditfixrrbusiness_businesssettings.mp4"
        />
        <!-- end tutorial models -->

    </div>
    <div v-else-if="BusinessStore.business && userStore.user && userStore.user.isTeamMember">
        <div v-if="BusinessStore.business && !team" class="row match-height mx-auto my-auto" >
            <div class="col-12">
                <div class="alert alert-warning" role="alert">
                    <div class="alert-body">
                        {{ localizationStore.translate('team.member.team.missing.message') }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row match-height mx-auto my-auto" >
            <div v-if="!userStore.user.ownerHasPlan" class="col-12">
                <div class="alert alert-warning" role="alert">
                    <div class="alert-body">
                        {{ localizationStore.translate('team.owner.plan.missing.message') }}
                    </div>
                </div>
            </div>
            <business-clients />
        </div>
        <clients-table v-if="team && userStore.user.ownerHasPlan" :teamMember="userStore.user.isTeamMember" :teamAdmin="userStore.user.isBusiness" :team="team" />
    </div>
    <loading v-else/>
</template>
<script>
import { ref, reactive } from 'vue'
import BusinessClients from "./BusinessComponents/BusinessClients.vue"
import BusinessCompanyDetails from "./BusinessComponents/BusinessCompanyDetails.vue"
import BusinessSettings from "./BusinessComponents/BusinessSettings.vue"
import { useMessageStore } from '../../stores/MessageStore.js'
import { useBusinessStore } from '../../stores/BusinessStore.js'
import { useBillingStore } from '../../stores/BillingStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'
import CompanyDetailModal from './BusinessComponents/modals/CompanyDetailModal.vue'
import AddClientModal from './BusinessComponents/modals/AddClientModal.vue'
import CompanyBusinessSetting from './BusinessComponents/modals/CompanyBusinessSetting.vue'
import ClientsTable from './BusinessComponents/ClientsTable.vue'
import VideoPlayerComponent from './tutorials/VideoPlayerComponent.vue'
import Loader from '../report/Loader.vue'
import { loadTour } from "./Tours/dashboard_tour.js"
import { closeModal, openModal, hideModal } from '../../utilities/_helpers'

export default{
    components:{
        BusinessClients,
        BusinessCompanyDetails,
        BusinessSettings,
        CompanyDetailModal,
        CompanyBusinessSetting,
        ClientsTable,
        AddClientModal,
        VideoPlayerComponent,
        'loading': Loader,
    },
    props:{

    },
    setup() {
        return{
            openModal,
            BusinessStore: useBusinessStore(),
            billingStore: useBillingStore(),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            messageStore: useMessageStore(),
            settingStore: useSettingStore(),
            team: ref(null),
            loadTour:loadTour,
            _: _,
        }
    },
    watch: {
        async 'BusinessStore.business' (value) {
            this.team = value.team ? value.team.id : null
        },
    },
    beforeMount(){
        this.BusinessStore.fetchBusiness()
        this.userStore.fetchUser();
        this.userStore.fetchCheckValidUserDispute();
        this.settingStore.fetchSetting();
        this.settingStore.tour_setup.step_name = 'business_dashboard_tour';
    },
    created(){

    },
    mounted(){
        let $this = this, route = $this.$router.resolve(
            {
                name: 'rooms'
            }
        );
        if ($this.messageStore.chats.isLoading == false) {
            $this.messageStore.fetchChats(route.href);
        }
        this.loadTour(this.settingStore.tour_setup.step_name,true)
    },
    methods: {
        isMobileOrTablet() {
            const mobileAndTabletQuery = window.matchMedia('(max-width: 1200px)');
            return mobileAndTabletQuery.matches;
        },
    },

}
</script>
